module.exports = __webpack_public_path__ + "img/madrid_salamanca.c4f54b75.jpg";